<template>
  <div class="container">
    <div class="redeemThePrize-container">
      <div class="redeemThePrize-section">
        <header class="redeemThePrize-header">
          <p class="title">兑换奖品</p>
          <div class="link">
            <router-link :to="{ name: 'my_prize' }" class="link-prize"
              >我的奖品</router-link
            >
            <router-link :to="{ name: 'my_site' }" class="link-site"
              >我的地址</router-link
            >
          </div>
        </header>
        <div class="redeemThePrize-body_container">
          <div class="temporary_show-container" v-if="giftList.length === 0">
            暂无数据
          </div>
          <div class="redeemThePrize-list" v-loading="loading">
            <div
              class="redeemThePrize-list_item"
              v-for="item in giftList"
              :key="item.gift_id"
            >
              <img :src="item.image.file_src" alt="" class="image" />
              <div class="desc">
                <p class="desc-title">{{ item.name }}</p>
                <p class="desc-quantity">库存数量：{{ item.left_number }}</p>
              </div>
              <div class="redeem">
                <p class="redeem_quantity">{{ item.integral }} 积分</p>
                <el-button
                  class="redeem_quit-handle"
                  @click="handleOpenDialog(item.id)"
                  >兑换</el-button
                >
              </div>
            </div>
          </div>
          <el-pagination
            background
            layout="prev, pager, next"
            :page-size="pageSize"
            :current-page="currentPage"
            :total="total"
            @current-change="editCurrentPage"
          >
          </el-pagination>
          <el-dialog :visible.sync="exchangeDialog" class="exchange-dialog">
            <el-form :model="exchangeForm">
              <el-form-item label="收货地址">
                <el-select
                  v-model="exchangeForm.address"
                  placeholder="请选择收货地址"
                  @change="handleChangeAddress"
                  class="form-input"
                >
                  <el-option
                    v-for="item in addressList"
                    :key="item.index"
                    :value="item.id"
                    :label="item.name"
                  >
                    <span class="select-item-label">{{ item.name }}</span>
                    <span class="select-item-label">{{ item.phone }}</span>
                    <span class="select-item-label">{{ item.address }}</span>
                  </el-option>
                </el-select>
                <div class="site-section_content" v-loading="selectLoading">
                  <div class="content-item">
                    <p class="label">
                      地址信息：
                    </p>
                    <p class="desc">{{ addressInfo.address }}</p>
                  </div>
                  <div class="content-item">
                    <p class="label">
                      收货人姓名：
                    </p>
                    <p class="desc">{{ addressInfo.name }}</p>
                  </div>
                  <div class="content-item">
                    <p class="label">
                      收货人电话：
                    </p>
                    <p class="desc">{{ addressInfo.phone }}</p>
                  </div>
                  <span @click="handleAddAddress" class="add-button"
                    >添加地址</span
                  >
                </div>
              </el-form-item>
              <el-form-item label="兑换数量" prop="number">
                <el-input-number
                  v-model="exchangeForm.number"
                  controls-position="right"
                ></el-input-number>
                <span class="tip">单位/件</span>
              </el-form-item>
            </el-form>
            <template slot="footer">
              <el-button size="medium" @click="exchangeDialog = false"
                >取消</el-button
              >
              <el-button type="primary" size="medium" @click="handleSubmit"
                >提交</el-button
              >
            </template>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import giftService from "@/global/service/gift.js";
export default {
  data() {
    return {
      giftList: [],
      pageSize: 10,
      pageCount: null,
      total: null,
      currentPage: 1,
      exchangeDialog: false,
      exchangeForm: {
        address: null,
        number: 1
      },
      addressList: [],
      addressInfo: {},
      giftId: null,
      selectLoading: false,
      loading: false
    };
  },
  created() {
    giftService.addressList().then(res => {
      this.addressList = res;
    });
    this.getDefaultAddress();
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      const params = {
        page: this.currentPage,
        page_size: this.pageSize
      };
      giftService
        .list(params)
        .then(res => {
          this.giftList = res.list;
          this.total = res.pagination.total;
          this.currentPage = res.pagination.current_page;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    editCurrentPage(index) {
      this.currentPage = index;
      this.getData();
    },
    handleChangeAddress(e) {
      this.selectLoading = true;
      let result = [];
      result = this.addressList.filter(data => data.id === e);
      this.exchangeForm.address = result[0].id;
      this.addressInfo = result[0];
      this.selectLoading = false;
    },
    handleOpenDialog(id) {
      this.giftId = id;
      this.exchangeDialog = true;
    },
    getDefaultAddress() {
      giftService.addressDefault().then(res => {
        this.exchangeForm.address = res.id;
      });
    },
    handleAddAddress() {
      this.$router.push({
        name: "new_addres"
      });
    },
    handleSubmit() {
      const params = {
        number: this.exchangeForm.number,
        address_id: this.exchangeForm.address
      };
      const id = this.giftId;
      giftService
        .giftExchange(id, params)
        .then(() => {
          this.$message.success("已提交兑换，请等待审核");
          this.getData();
        })
        .finally(() => {
          this.exchangeDialog = false;
        });
    }
  }
};
</script>
<style lang="less" scoped>
.redeemThePrize-section {
  background-color: #fff;
  .redeemThePrize-header {
    display: flex;
    justify-content: space-between;
    padding: 10px;
    align-items: center;
    font-size: 12px;
    font-weight: 400;
    color: #2c3e50;
    border-bottom: 1px solid #dedede;
    .link {
      a {
        text-decoration: none;
        color: #f0b32f;
        margin: 0 10px;
      }
    }
  }
  .redeemThePrize-body_container {
    padding: 20px;
    .redeemThePrize-list {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      flex: 1;
      margin-bottom: 30px;
      .redeemThePrize-list_item {
        width: 48%;
        box-shadow: 0px 0px 2px 2px rgba(222, 222, 222, 0.8);
        margin-bottom: 20px;
        .image {
          display: block;
          width: 100%;
          height: 200px;
        }
        .desc {
          display: flex;
          justify-content: space-between;
          padding-left: 10px;
          font-size: 14px;
          color: #333;
          font-weight: 600;
          padding: 10px;
          border-bottom: 1px solid #dedede;
          .desc-title {
            flex: 1;
            margin-right: 10px;
            overflow: hidden;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            display: -webkit-box;
            text-overflow: ellipsis;
            text-align: left;
            height: 40px;
          }
        }
        .redeem {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 20px 0;
          a {
            text-decoration: none;
          }
          .redeem_quantity {
            width: 99px;
            height: 38px;
            line-height: 36px;
            font-size: 12px;
            color: #515a6e;
            border: 1px solid #dedede;
            border-radius: 20px 0 0 20px;
            border-right: none;
          }
          .el-button {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 99px;
            height: 38px;
            font-size: 12px;
            color: #515a6e;
            border: 1px solid #f0b32f;
            border-radius: 0 20px 20px 0;
            border-left: none;
            background-color: #f0b32f;
            color: #fff;
          }
        }
      }
    }
  }
  .exchange-dialog {
    /deep/ .el-form-item__content {
      text-align: left;
    }

    .site-section_content {
      margin-top: 15px;
      padding-left: 70px;
      position: relative;
      .content-item {
        display: flex;
      }
      .add-button {
        position: absolute;
        right: 20px;
        top: 40px;
        cursor: pointer;
      }
    }
    /deep/.el-dialog__footer {
      display: flex;
      justify-content: center;
    }
  }
  .form-input {
    width: 270px !important;
  }
  .tip {
    margin-left: 15px;
  }
}
</style>

<style lang="less">
.el-popup-parent--hidden {
  /deep/ .el-select-dropdown {
    .el-scrollbar {
      width: 300px;
      .el-select-dropdown__wrap {
        .el-select-dropdown__list {
          .el-select-dropdown__item {
            &.selected {
              font-weight: 400;
              color: #606266 !important;
            }
            &:hover {
              color: #409eff;
            }
          }
        }
      }
      .el-select-dropdown__item {
        .select-item-label {
          margin-right: 5px;
        }
      }
    }
  }
}
</style>
